export default "__VITE_ASSET__ynxjCudm__"